// PayOrderEdit.tsx
import PayOrderEditBase from './PayOrderEditBase';

const PayOrderEdit = (props: any) => (
    <PayOrderEditBase apiId="payOrder" outerProps={props} />
);

export default PayOrderEdit;